import Component from '@glimmer/component';
import isPresent from 'donor-elf-web/helpers/is-present';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import ContactModel from 'donor-elf-web/models/contact';
import MergeContactsSection from 'donor-elf-web/components/add-something-modal/merge-contacts/section';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import FormUnderlineText from 'donor-elf-web/components/form/underline/text';
import FormUnderlineSelect from 'donor-elf-web/components/form/underline/select';
import CopyPasteButton from 'donor-elf-web/components/add-something-modal/merge-contacts/copy-paste-button';

interface ComponentArgs {
  changeset: any;
  property: keyof ContactModel;
  propertyIsBoolean?: true;
  propertyLabel: string;
  contactToKeep: ContactModel;
  contactToMerge: ContactModel;
  showValidationErrors: boolean;
}

export default class AddSomethingModalMergeContactsMergePropertyComponent extends Component<ComponentArgs> {
  get contactToKeepValue() {
    if (this.args.propertyIsBoolean) {
      return this.args.contactToKeep[this.args.property] ? 'Yes' : 'No';
    }
    return this.args.contactToKeep[this.args.property];
  }

  get contactToMergeValue() {
    if (this.args.propertyIsBoolean) {
      return this.args.contactToMerge[this.args.property] ? 'Yes' : 'No';
    }
    return this.args.contactToMerge[this.args.property];
  }

  copyPropertyFrom = (contact: ContactModel) => {
    this.args.changeset.set(this.args.property, contact[this.args.property]);
  }

  <template>
    <div ...attributes>
      <MergeContactsSection
        @header={{@propertyLabel}}
      >
        <div>
          <div class='row'>
            <div class='col'>
              <FormUnderlineLabel
                @label='Value to Keep'
              >
                {{#if @propertyIsBoolean}}
                  <FormUnderlineSelect
                    @changeset={{@changeset}}
                    @property={{@property}}
                    @booleanOptions={{true}}
                    @showValidationErrors={{@showValidationErrors}}
                    @dropdownMatchTriggerWidth={{true}}
                    @dropdownContentClass='tw-z-1100'
                  />
                {{else}}
                  <FormUnderlineText
                    @changeset={{@changeset}}
                    @property={{@property}}
                    @showValidationErrors={{@showValidationErrors}}
                    class='w-100'
                  />
                {{/if}}
              </FormUnderlineLabel>
            </div>
            <div class='col'>
              <FormUnderlineLabel @label='Contact to Keep'>
                {{#if (isPresent this.contactToKeepValue)}}
                  <div class='d-flex'>
                    <div>
                      <CopyPasteButton
                        {{on 'click' (fn this.copyPropertyFrom @contactToKeep)}}
                      />
                    </div>
                    <div>
                      {{this.contactToKeepValue}}
                    </div>
                  </div>
                {{else}}
                  <div class='text-muted font-weight-light'>---</div>
                {{/if}}
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Contact to Merge'>
                {{#if (isPresent this.contactToMergeValue)}}
                  <div class='d-flex'>
                    <div>
                      <CopyPasteButton
                        {{on 'click' (fn this.copyPropertyFrom @contactToMerge)}}
                      />
                    </div>
                    <div>
                      {{this.contactToMergeValue}}
                    </div>
                  </div>
                {{else}}
                  <div class='text-muted font-weight-light'>---</div>
                {{/if}}
              </FormUnderlineLabel>
            </div>
          </div>
        </div>
      </MergeContactsSection>
    </div>
  </template>
}
